import * as React from 'react';

import { StoreType } from '@tock/shared/utils/connect';
import { initialAppState } from 'state/app';

export const ApplicationContext = React.createContext<StoreType['app']>(initialAppState);
export const MobileNativeContext = React.createContext<{
  mobileNative: boolean;
  reactNative: boolean;
}>({
  mobileNative: false,
  reactNative: false,
});

export const useMobileNativeContext = () => React.useContext(MobileNativeContext);

export const GoogleMapsContext = React.createContext<{ loaded: boolean; error?: Error }>({
  loaded: false,
  error: undefined,
});

export const useGoogleMapsContext = () => React.useContext(GoogleMapsContext);
export interface IApplicationContext {
  app: StoreType['app'];
}
export function withApplicationContext<P>(
  WrappedComponent: React.ComponentType<
    P & IApplicationContext & React.ClassAttributes<HTMLElement>
  >
): React.ComponentClass<P> {
  class WithApplicationContext extends React.Component<P> {
    static displayName: string;
    render() {
      return (
        <ApplicationContext.Consumer>
          {(app: StoreType['app']) => <WrappedComponent {...this.props} app={app} />}
        </ApplicationContext.Consumer>
      );
    }
  }

  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  WithApplicationContext.displayName = `WithApplicationContext(${wrappedComponentName})`;

  return WithApplicationContext;
}
